import { render, staticRenderFns } from "./KPIScreen.vue?vue&type=template&id=3255dd8d&"
import script from "./KPIScreen.vue?vue&type=script&lang=js&"
export * from "./KPIScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports